import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';
import { UserCapabilityName } from '../../types/userCapabilityName';
import { policyMgrAnalytics } from './types/policyManagerAnalytics';

const PolicyManager = lazy(
  () => import(/* webpackChunkName: "policy-manager" */ './PolicyManager')
);

const PolicyManagerForm = lazy(
  () =>
    // FIXME: Components shouldn't be routed to directly, instead convert this to a page by moving from `./components`/ to `./PolicyManager` root.
    import(
      /* webpackChunkName: "policy-manager-form" */ './components/PolicyManagerForm/PolicyManagerForm'
    )
);

const { policyManager, createPolicy, editPolicy } = policyMgrAnalytics;

export const policyManagerRoutes = (
  <Route path="policy-manager/*">
    <Route
      path=""
      element={
        <PageRoute
          pageInfo={policyManager}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.ViewInternalAccessPolicies,
            UserCapabilityName.ViewAccessPolicies,
          ]}
        >
          <PolicyManager />
        </PageRoute>
      }
    />
    <Route
      path="create"
      element={
        <PageRoute
          pageInfo={createPolicy}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.CreateInternalAccessPolicy,
            UserCapabilityName.CreateAccessPolicy,
          ]}
        >
          <PolicyManagerForm />
        </PageRoute>
      }
    />
    <Route
      path="edit"
      element={
        <PageRoute
          pageInfo={editPolicy}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditInternalAccessPolicy,
            UserCapabilityName.EditAccessPolicy,
          ]}
        >
          <PolicyManagerForm />
        </PageRoute>
      }
    />
  </Route>
);
